import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { connect } from '../../../../redux/connect';
import { isFetchReportLoading } from '../../../../redux/selectors';
import { fetchIssuesReport } from '../../../../redux/actions';
import SortingAndFiltering from './components/SortingAndFiltering';
import { IconButton, SvgIcon, Tooltip } from '@adsk/bim360-matrix-react-components';
import exportIcon from '../../../../assets/images/icons/icon-export.svg';

export class PureIssuesPanelHeader extends PureComponent {
  _renderExportCsvWithToolTip() {
    return (
      <Tooltip
        theme={Tooltip.Themes.DARK}
        place={Tooltip.Places.TOP}
        content={this.props.isFetchReportLoading ? T.translate('export.exporting') : T.translate('export.export')}
      >
        <IconButton
          className="IssuesPanelHeader__export-button"
          onClick={this.props.fetchIssuesReport}
          disabled={this.props.isFetchReportLoading}
        >
          <SvgIcon width="20px" height="20px">
            {exportIcon}
          </SvgIcon>
        </IconButton>
      </Tooltip>
    );
  }

  _renderExportButton() {

    return (
      <div className="IssuesPanelHeader__export">
        {this._renderExportCsvWithToolTip(this.props)}
      </div>
    );
  }

  render() {
    return (
      <div className="IssuesPanelHeader">
        <SortingAndFiltering />
        {this._renderExportButton()}
      </div>
    );
  }
}

PureIssuesPanelHeader.displayName = 'IssuesPanelHeader';

PureIssuesPanelHeader.propTypes = {
  isFetchReportLoading: PropTypes.bool,
  fetchIssuesReport: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isFetchReportLoading: isFetchReportLoading(state),
});

const mapDispatchToProps = {
  fetchIssuesReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(PureIssuesPanelHeader);
